import { apiService } from '../api/api.service';
import { JoinCondition } from './join-condition.model';
class JoinConditionService {
    async getListByCampaign(campaignId): Promise<JoinCondition[]> {
        let result = await apiService.get("join-condition/list-by-campaign", {campaignId});
        if (!apiService.generalProcessDataResponse(result)) return [];
        return result.data;
    }
}
export default new JoinConditionService();